import { Consumer } from "../models/SRCiInputData"

export type ConsumerPrefillScenario = "complete" | "partial" | "empty"

export const getConsumerPrefill = (scenario: ConsumerPrefillScenario): Consumer => {
  switch (scenario) {
    case "complete":
      return {
        emailAddress: "alex.taylor@example.com",
        firstName: "Alex",
        lastName: "Taylor",
        mobileNumber: {
          countryCode: "46",
          phoneNumber: "701234567",
        },
        countryCode: "SE",
        consumerIdentity: {
          identityProvider: "SRC",
          identityType: "EMAIL_ADDRESS",
          identityValue: "alex.taylor@example.com",
        },
      }
    case "partial":
      return {
        emailAddress: "alex.taylor@example.com",
        firstName: "",
        lastName: "Taylor",
        mobileNumber: {
          countryCode: "48",
          phoneNumber: "501234567",
        },
        countryCode: "",
        consumerIdentity: {
          identityProvider: "SRC",
          identityType: "EMAIL_ADDRESS",
          identityValue: "alex.taylor@example.com",
        },
      }
    case "empty":
      return {
        emailAddress: "",
        firstName: "",
        lastName: "",
        mobileNumber: {
          countryCode: "",
          phoneNumber: "",
        },
        countryCode: "",
        consumerIdentity: {
          identityProvider: "SRC",
          identityType: "EMAIL_ADDRESS",
          identityValue: "",
        },
      }
  }
}
